import React from 'react';
import {siteData} from '../../data/content';
import * as FiIcons from 'react-icons/fi';
const {FiPhone,FiArrowRight}=FiIcons;

const BG_IMG="https://images.unsplash.com/photo-1514316454349-750a7fd3da3a?auto=format&fit=crop&q=80";
const BOOKING_URL="https://app.urable.com/virtual-shop/cFNwotdAvEx76Evup5X1";

export default function CTASection() {
  return ( 
    <section className="py-24 bg-blue-600 relative overflow-hidden"> 
      <div className="absolute inset-0 opacity-10 mix-blend-multiply bg-cover bg-center" style={{backgroundImage: `url('${BG_IMG}')`}} /> 
      <div className="max-w-4xl mx-auto px-4 text-center relative z-10"> 
        <span className="text-blue-200 text-xs font-bold uppercase tracking-widest mb-4 block"> 
          Jacksonville,FL & Surrounding Areas 
        </span> 
        <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight mb-6 drop-shadow-md"> 
          Ready for a Showroom Finish? 
        </h2> 
        <p className="text-blue-100 text-lg mb-10 max-w-2xl mx-auto font-medium"> 
          Book your premium auto detailing service today. Fresh Ride,Gloss Boss,Elite Detail — we've got you covered. 
        </p> 
        <div className="flex flex-col sm:flex-row justify-center gap-4"> 
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-sm font-bold tracking-wide uppercase text-sm bg-white text-blue-700 hover:bg-slate-100 transition-all" > 
            Book Now <FiArrowRight /> 
          </a> 
          <a href={`tel:${siteData.business.phoneTel}`} className="inline-flex items-center justify-center gap-2 px-7 py-4 border-2 border-white/40 text-white font-bold hover:bg-white/10 transition-colors rounded-sm uppercase tracking-wide text-sm" > 
            <FiPhone className="text-sm" /> Call Now — {siteData.business.phone} 
          </a> 
        </div> 
      </div> 
    </section> 
  );
}